const defaultMenuIcon = {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-322dfea3c941406ca0ff8dcc93bb5285',
    meta: {
        previousId: 'builder-114df8fd11c4477fbdaf96b43a769be9'
    },
    component: {
        name: 'IconPicker',
        options: {
            iconName: 'MobileMenu'
        }
    },
    responsiveStyles: {
        large: {
            color: 'rgba(85, 68, 151, 1)',
            width: '15px',
            height: '15px',
            display: 'flex'
        },
        medium: {
            display: 'flex'
        },
        small: {
            display: 'flex'
        }
    }
}
const defaultMenuText = {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    layerName: 'Shop',
    id: 'builder-121f91bfde2b4525b03e58afd87dc001',
    meta: {
        previousId: 'builder-68cb0f351cf0438bb4792e94bd9cfb09'
    },
    component: {
        name: 'Text',
        options: {
            text: '<p class="body-lg"><strong><span class="body-lg">﻿</span><span class="body-md">Menu</span></strong></p>'
        }
    },
    responsiveStyles: {
        large: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            lineHeight: '16px',
            height: 'auto',
            marginLeft: '4px',
            color: 'rgba(85, 68, 154, 0.99)',
            fontWeight: '400',
            fontFamily: '"grotesque", sans-serif',
            width: '50px',
            textAlign: 'center'
        },
        medium: {
            display: 'flex'
        },
        small: {
            display: 'none'
        }
    }
}

export const defaultDrawerChildren = {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    id: 'builder-031825f171634a91b1a35c6c475cb73e',
    children: [defaultMenuIcon, defaultMenuText],
    responsiveStyles: {
        large: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }
}
